import { createAsyncThunk } from '@reduxjs/toolkit'
import { Payload } from 'stores'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import {
  STORE_BILL_CURRENT,
  STORE_BILL_CURRENT_FETCH,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import { Bill, BillStatus, ErrorStore } from '@types'

type State = GenericState<Bill>

export const initialState: State = {
  data: {
    payable: false,
    due_date: '',
    closing_date: '',
    effective_due_date: '',
    minimum_amount: 0,
    spent_amount: 0,
    paid_amount: 0,
    due_amount: 0,
    balance: 0,
    deliquency_fine_rate: 0,
    line_item_groups: [],
    id: '',
    status: BillStatus.Open,
    flags: {
      is_empty: false,
      is_zero: false,
      has_debit: false,
      show_amounts_header: false,
    },
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchCurrent = createAsyncThunk<Bill, Promise<Bill>, Payload>(
  STORE_BILL_CURRENT_FETCH,
  async (promise, { rejectWithValue }) => {
    try {
      return await promise
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<Bill, Bill, Payload>(
  fetchCurrent,
  initialState.data
)

const slice = createGenericSlice({
  name: STORE_BILL_CURRENT,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = slice

const { clear, success } = actions

export { clear, success }

export default reducer
